import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Select } from '@ngxs/store';
import { Deal } from 'app/models/dto/deal.model';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { Offer } from 'app/services/offers/offer.model';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-deal-actions',
  templateUrl: './deal-actions.component.html',
  styleUrls: ['./deal-actions.component.scss'],
})
export class DealActionsComponent implements OnInit, OnChanges {

  @Input() bulkSubmitting = false;
  @Input() deal: Deal;
  @Input() set dealStatus(status: string) {
    this._dealStatus = status;
  }
  get dealStatus(): string {
    return this._dealStatus;
  }
  _dealStatus: string;
  @Input() offers: Offer[];
  @Input() docRequirementsMet: boolean;
  @Input() questionRequirementsMet: boolean;
  @Input() loading: boolean;
  @Input() hasActiveApplication: boolean;
  @Input() dateSigned: string;
  @Input() ringingDeal: boolean;

  @Output() offerReceived = new EventEmitter();
  @Output() renew = new EventEmitter();
  @Output() ringDeal = new EventEmitter();
  @Output() send = new EventEmitter();
  @Output() sendViaAPI = new EventEmitter();
  @Output() reactivate = new EventEmitter();

  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

  canManageDeals: boolean;
  buttonsContext: {
    dealIsActive: boolean;
    disablePackageAndSend: boolean;
    hasAcceptedOffer: boolean;
    showOfferReceivedButton: boolean;
    showSendToLenderButtons: boolean;
    showRingDealButton: boolean;
    showRenewDealButton: boolean;
  };

  constructor() { }

  ngOnInit(): void {
    this.lenderUser$.pipe(
      take(1)).subscribe(
      (user) => {
      this.canManageDeals = user?.permissions?.includes('manageDeals');
    });
    this.setButtonsContext();
  }

  ngOnChanges(): void {
    this.setButtonsContext();
  }

  setButtonsContext(): void {
    this.buttonsContext = {
      dealIsActive: this.dealIsActive(),
      disablePackageAndSend: this.disablePackageAndSend(),
      hasAcceptedOffer: this.hasAcceptedOffer(),
      showOfferReceivedButton: this.showOfferReceivedButton(),
      showSendToLenderButtons: this.showSendToLenderButtons(),
      showRingDealButton: this.showRingDealButton(),
      showRenewDealButton: this.showRenewDealButton(),
    };
  }

  showSendToLenderButtons() {
    return (
      this.canManageDeals
      && !this.hasActiveApplication
      && this.offers.length === 0
      && this.deal.stage === 'application'
    );
  }

  hasAcceptedOffer() {
    return this.offers.filter(o => o.accepted).length > 0;
  }

  dealIsActive() {
    return this.deal.stage !== 'inactive' && this.deal.stage !== 'funded';
  }

  showOfferReceivedButton() {
    return (
      this.canManageDeals
      && this.dealIsActive()
      && !this.deal.dateClosed
      && this.hasActiveApplication
      && this.offers.length === 0
      && this.deal.stage !== 'closing'
    );
  }

  showRingDealButton() {
    return (
      this.canManageDeals
      && this.dealIsActive()
      && (!this.deal.dateClosed && this.offers.length > 0)
      && (this.deal.stage === 'closing' || this.dealStatus === 'offerAccepted' || this.dealStatus === 'offerReceived')
    );
  }

  showRenewDealButton() {
    return this.deal.stage === 'funded' && this.canManageDeals;
  }

  disablePackageAndSend() {
    return this.dealStatus !== 'appComplete' || !this.docRequirementsMet || this.loading;
  }

  openOfferDialog() {
    this.offerReceived.emit();
  }

  openReactivateDealDialog() {
    this.reactivate.emit();
  }

  renewDeal() {
    this.renew.emit();
  }

  openRingDealDialog() {
    this.ringDeal.emit();
  }

  sendApplication() {
    this.send.emit();
  }

  sendAPIApplication() {
    this.sendViaAPI.emit();
  }
}
